import AxiosConfig from "@/config/axiosConfig/AxiosConfig";
import config from "@/config";

const CompanyService = {
    getCompany: async (params) => {
        try {
            const response = await AxiosConfig.get(config.api.company + '/CompanyList', { params });
            return response.data;
        } catch (error) {
            console.error('Error:', error);
            return Promise.reject(error);
        }
    },
    getCompanyById : async (id,params) => {
        try {
            const response = await AxiosConfig.get(config.api.company + `/${id}`, { params });
            return response.data;
        } catch (error) {
            console.error('Error:', error);
            return Promise.reject(error);
        }
    },
}

export default CompanyService;